import { Navigate, Outlet, type RouteObject } from "react-router";
import { dashboardRoutes } from "./dashboard";
import { mainRoutes } from "./main";

import { LineLoading } from "@/components/loading";
import { Suspense, lazy } from "react";

const LoginPage = lazy(() => import("@/pages/sys/login"));
const ResetPassword = lazy(() => import("@/pages/sys/resetPassword"));

export const routesSection: RouteObject[] = [
	// Auth
	{
		path: "auth",
		element: (
			<Suspense fallback={<LineLoading />}>
				<Outlet />
			</Suspense>
		),
		children: [
			{
				path: "login",
				element: <LoginPage />,
			},
			{
				path: "reset-password",
				element: <ResetPassword />,
			},
		],
	},
	// Dashboard
	...dashboardRoutes,
	// Main
	...mainRoutes,
	// No Match
	{ path: "*", element: <Navigate to="/404" replace /> },
];
